import { apiClient } from '@app/api';
import { OptionType } from '@app/components/stations/advanced-filter';
import { SelectField } from '@mi-front/ui';
import { useQuery } from '@tanstack/react-query';
import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';

export const VersionsField = () => {
  const { $t } = useIntl();
  const { values } = useFormikContext<GipReportValues>();
  const queryEnabled = !!(values.advertisers.length && values.campaigns.length);

  const stationsIds =
    values.stationsFilter
      ?.filter((s) => s.type === OptionType.IndividualStation)
      .map((s) => s.value.id) ??
    values.stations?.map((s) => s.id) ??
    [];

  const params = {
    from: values.from,
    to: values.to,
    stations: stationsIds,
    advertisers: values.advertisers.map((v) => v.name),
    campaigns: values.campaigns.map((v) => v.name),
  };
  const query = useQuery({
    queryKey: ['gip-report-versions', params],

    queryFn: () =>
      apiClient.audit.gipFetchVersions(params).then((values) => values.filter((v) => !!v)),

    enabled: queryEnabled,
  });

  return (
    <SelectField
      name="versions"
      label={$t({
        id: 'audit.gipReport.form.versions',
        defaultMessage: 'Versiones',
      })}
      placeholder={$t({
        id: 'audit.gipReport.form.allVersions',
        defaultMessage: 'Todas las versiones',
      })}
      options={query.data?.map((name) => ({ name }))}
      multiple
      isClearable
      isSearchable
      getOptionLabel={(value) => value.name}
      getOptionValue={(value) => value.name}
      isLoading={query.isFetching}
    />
  );
};
